// Garmin part number → the name Profile shows for the paired watch.
//
// The watch can't name its own product — Monkey C only has
// System.DeviceSettings.partNumber, which it sends on sync and the server
// keeps in device_tokens.device_part (029). Names come from the Connect IQ
// SDK's Devices/<id>/compiler.json (displayName, trademark signs dropped), at
// least one entry per product in watch/manifest.xml (`make versions` fails on a
// product missing here) and one per part number: a product id can cover several
// part numbers (regions, editions), and the watch reports the part. Where the
// SDK puts several models under one id, the entry names the main one.
// A part we don't know yields null, and Profile falls back to "Watch".
export const WATCHES = [
  { product: 'fr165',                   part: '006-B4432-00', name: 'Forerunner 165' },
  { product: 'fr165m',                  part: '006-B4433-00', name: 'Forerunner 165 Music' },
  { product: 'fr170',                   part: '006-B4815-00', name: 'Forerunner 170' },
  { product: 'fr170m',                  part: '006-B4814-00', name: 'Forerunner 170 Music' },
  { product: 'fr255',                   part: '006-B3992-00', name: 'Forerunner 255' },
  { product: 'fr255m',                  part: '006-B3990-00', name: 'Forerunner 255 Music' },
  { product: 'fr255s',                  part: '006-B3993-00', name: 'Forerunner 255S' },
  { product: 'fr255sm',                 part: '006-B3991-00', name: 'Forerunner 255S Music' },
  { product: 'fr265',                   part: '006-B4257-00', name: 'Forerunner 265' },
  { product: 'fr265s',                  part: '006-B4258-00', name: 'Forerunner 265S' },
  { product: 'fr70',                    part: '006-B4916-00', name: 'Forerunner 70' },
  { product: 'fr70',                    part: '006-B5214-00', name: 'Forerunner 70' },
  { product: 'fr57042mm',               part: '006-B4574-00', name: 'Forerunner 570 42mm' },
  { product: 'fr57047mm',               part: '006-B4570-00', name: 'Forerunner 570 47mm' },
  { product: 'fr955',                   part: '006-B4024-00', name: 'Forerunner 955' },
  { product: 'fr965',                   part: '006-B4315-00', name: 'Forerunner 965' },
  { product: 'fr970',                   part: '006-B4565-00', name: 'Forerunner 970' },
  { product: 'fenix7',                  part: '006-B3906-00', name: 'fēnix 7' },
  { product: 'fenix7',                  part: '006-B3909-00', name: 'fēnix 7' },
  { product: 'fenix7s',                 part: '006-B3905-00', name: 'fēnix 7S' },
  { product: 'fenix7s',                 part: '006-B3908-00', name: 'fēnix 7S' },
  { product: 'fenix7x',                 part: '006-B3907-00', name: 'fēnix 7X' },
  { product: 'fenix7x',                 part: '006-B3910-00', name: 'fēnix 7X' },
  { product: 'fenix7x',                 part: '006-B4135-00', name: 'fēnix 7X' },
  { product: 'fenix7x',                 part: '006-B4341-00', name: 'fēnix 7X' },
  { product: 'fenix7pro',               part: '006-B4375-00', name: 'fēnix 7 Pro' },
  { product: 'fenix7spro',              part: '006-B4374-00', name: 'fēnix 7S Pro' },
  { product: 'fenix7xpro',              part: '006-B4376-00', name: 'fēnix 7X Pro' },
  { product: 'fenix7pronowifi',         part: '006-B4595-00', name: 'fēnix 7 Pro Solar' },
  { product: 'fenix7xpronowifi',        part: '006-B4596-00', name: 'fēnix 7X Pro Solar' },
  { product: 'fenix843mm',              part: '006-B4534-00', name: 'fēnix 8 43mm' },
  { product: 'fenix847mm',              part: '006-B4536-00', name: 'fēnix 8' },
  { product: 'fenix847mm',              part: '006-B4775-00', name: 'fēnix 8' },
  { product: 'fenix8solar47mm',         part: '006-B4532-00', name: 'fēnix 8 Solar 47mm' },
  { product: 'fenix8solar51mm',         part: '006-B4533-00', name: 'fēnix 8 Solar 51mm' },
  { product: 'fenix8solar51mm',         part: '006-B4776-00', name: 'fēnix 8 Solar 51mm' },
  { product: 'fenix8pro47mm',           part: '006-B4631-00', name: 'fēnix 8 Pro' },
  { product: 'fenixe',                  part: '006-B4666-00', name: 'fēnix E' },
  { product: 'fenix943mm',              part: '006-B5133-00', name: 'fēnix 9 43mm' },
  { product: 'fenix947mm',              part: '006-B5134-00', name: 'fēnix 9' },
  { product: 'fenix9pro43mm',           part: '006-B4952-00', name: 'fēnix 9 Pro 43mm' },
  { product: 'fenix9pro47mm',           part: '006-B4953-00', name: 'fēnix 9 Pro 47mm' },
  { product: 'fenix9pro51mm',           part: '006-B4954-00', name: 'fēnix 9 Pro 51mm' },
  { product: 'fenix9prosolar47mm',      part: '006-B4955-00', name: 'fēnix 9 Pro Solar 47mm' },
  { product: 'fenix9prosolar51mm',      part: '006-B4956-00', name: 'fēnix 9 Pro Solar 51mm' },
  { product: 'epix2',                   part: '006-B3943-00', name: 'epix (Gen 2)' },
  { product: 'epix2',                   part: '006-B3944-00', name: 'epix (Gen 2)' },
  { product: 'epix2pro42mm',            part: '006-B4312-00', name: 'epix Pro 42mm' },
  { product: 'epix2pro47mm',            part: '006-B4313-00', name: 'epix Pro 47mm' },
  { product: 'epix2pro51mm',            part: '006-B4314-00', name: 'epix Pro 51mm' },
  { product: 'epix2pro51mm',            part: '006-B4542-00', name: 'epix Pro 51mm' },
  { product: 'epix2pro51mm',            part: '006-B4556-00', name: 'epix Pro 51mm' },
  { product: 'enduro3',                 part: '006-B4575-00', name: 'Enduro 3' },
  { product: 'enduro4',                 part: '006-B5169-00', name: 'Enduro 4' },
  { product: 'venu2',                   part: '006-B3703-00', name: 'Venu 2' },
  { product: 'venu2',                   part: '006-B3950-00', name: 'Venu 2' },
  { product: 'venu2',                   part: '006-B4171-00', name: 'Venu 2' },
  { product: 'venu2',                   part: '006-B4180-00', name: 'Venu 2' },
  { product: 'venu2s',                  part: '006-B3704-00', name: 'Venu 2S' },
  { product: 'venu2s',                  part: '006-B3949-00', name: 'Venu 2S' },
  { product: 'venu2s',                  part: '006-B4175-00', name: 'Venu 2S' },
  { product: 'venu2s',                  part: '006-B4181-00', name: 'Venu 2S' },
  { product: 'venu2plus',               part: '006-B3851-00', name: 'Venu 2 Plus' },
  { product: 'venu2plus',               part: '006-B4017-00', name: 'Venu 2 Plus' },
  { product: 'venu3',                   part: '006-B4260-00', name: 'Venu 3' },
  { product: 'venu3s',                  part: '006-B4261-00', name: 'Venu 3S' },
  { product: 'venu441mm',               part: '006-B4644-00', name: 'Venu 4 41mm' },
  { product: 'venu445mm',               part: '006-B4643-00', name: 'Venu 4 45mm' },
  { product: 'venu445mm',               part: '006-B4944-00', name: 'D2 Air X15' },
  { product: 'venux1',                  part: '006-B4603-00', name: 'Venu X1' },
  { product: 'venusq2',                 part: '006-B4115-00', name: 'Venu Sq 2' },
  { product: 'venusq2m',                part: '006-B4116-00', name: 'Venu Sq 2 Music' },
  { product: 'vivoactive5',             part: '006-B4426-00', name: 'vívoactive 5' },
  { product: 'vivoactive6',             part: '006-B4625-00', name: 'vívoactive 6' },
  { product: 'instinct3amoled45mm',     part: '006-B4586-00', name: 'Instinct 3 AMOLED 45mm' },
  { product: 'instinct3amoled50mm',     part: '006-B4587-00', name: 'Instinct 3 AMOLED 50mm' },
  { product: 'instinctcrossoveramoled', part: '006-B4678-00', name: 'Instinct Crossover AMOLED' },
  { product: 'marq2',                   part: '006-B4105-00', name: 'MARQ (Gen 2)' },
  { product: 'marq2',                   part: '006-B4472-00', name: 'MARQ (Gen 2)' },
  { product: 'marq2aviator',            part: '006-B4124-00', name: 'MARQ Aviator (Gen 2)' },
  { product: 'd2mach1',                 part: '006-B4079-00', name: 'D2 Mach 1' },
  { product: 'd2mach2',                 part: '006-B4879-00', name: 'D2 Mach 2' },
  { product: 'd2mach2pro',              part: '006-B5056-00', name: 'D2 Mach 2 Pro' },
  { product: 'd2airx10',                part: '006-B4125-00', name: 'D2 Air X10' },
  { product: 'descentmk343mm',          part: '006-B4222-00', name: 'Descent Mk3 43mm' },
  { product: 'descentmk351mm',          part: '006-B4223-00', name: 'Descent Mk3i 51mm' },
  { product: 'descentg2',               part: '006-B4588-00', name: 'Descent G2' },
  { product: 'approachs50',             part: '006-B4656-00', name: 'Approach S50' },
  { product: 'approachs7042mm',         part: '006-B4233-00', name: 'Approach S70 42mm' },
  { product: 'approachs7047mm',         part: '006-B4234-00', name: 'Approach S70 47mm' },
  { product: 'approachs7243mm',         part: '006-B4874-00', name: 'Approach S72 43mm' },
  { product: 'approachs7247mm',         part: '006-B4875-00', name: 'Approach S72 47mm' },
] as const

export function watchName(part: string | null | undefined): string | null {
  const key = part?.toUpperCase()
  return WATCHES.find((w) => w.part === key)?.name ?? null
}
